export const fr = {
  title: `Sommeil`,
  p1: `Les crises nocturnes et les médicaments anticonvulsivant peuvent perturber le sommeil. À l’inverse, le sommeil peut également affecter l’épilepsie puisqu’un manque de repos est un des facteurs déclencheurs de crises.`,
  p2: `Voici des comportements à adopter afin de minimiser l’impact du manque de sommeil sur les crises d’épilepsie :`,
  bullets: [
    `Se coucher tôt`,
    `Réduire sa consommation de caféine et d’alcool`,
    `Éviter de trop manger avant de se coucher`,
    `Conserver un horaire de sommeil régulier`,
    `Prendre sa médication de manière régulière`,
    `Opter pour des environnements calmes`,
    `Éviter les écrans au moins une heure avant le coucher`
  ]
};
